import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { FieldArray } from "formik";
import { CustomFormField, FormField } from "../../../../Form/FormField";
import { SectionWrapper } from "../../../../UI/SectionWrapper/SectionWrapper";
import LanguageTabs from "../../../ui-components/pageLayout/LanguageTabs";

interface ILocalizedTextsProps {}

const LocalizedTextsAccordion: React.FC<ILocalizedTextsProps> = (props) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>("en");
  // can be fetched async per customer and stored in store
  const availableLanguages = ["en", "sv", "no"];

  return (
    <SectionWrapper>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Localized title & descriptions
        </AccordionSummary>
        <AccordionDetails style={{ paddingTop: "0px" }}>
          <FieldArray
            name="localizedInfo"
            render={({ form, push }) => {
              // Find the index of the localized info for the selected language
              const localizedIndex = form.values.localizedInfo?.findIndex(
                (info: any) =>
                  info.language?.toLowerCase() ===
                  selectedLanguage.toLowerCase()
              );

              return (
                <>
                  <LanguageTabs
                    languages={availableLanguages}
                    setLanguageIndex={(index) => {
                      const language = availableLanguages[index];
                      setSelectedLanguage(language);

                      // Check if this language exists in localizedInfo
                      const exists = form.values.localizedInfo?.some(
                        (info: any) =>
                          info.language?.toLowerCase() ===
                          language.toLowerCase()
                      );

                      if (!exists) {
                        push({
                          language: language.toLowerCase(),
                          synopsisLong: "",
                          synopsisMedium: "",
                          synopsisShort: "",
                          title: "",
                        });
                      }
                    }}
                  />
                  {localizedIndex !== -1 && (
                    <Grid container spacing={2}>
                      {/*<Grid item xs={6}>*/}
                      {/*  <FormField*/}
                      {/*    name={`localizedInfo[${localizedIndex}].language`}*/}
                      {/*    label="language"*/}
                      {/*    placeholder="language..."*/}
                      {/*  />*/}
                      {/*</Grid>*/}
                      <Grid item xs={6}>
                        <FormField
                          name={`localizedInfo[${localizedIndex}].title`}
                          label="Title"
                          placeholder="Title..."
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustomFormField
                          name={`localizedInfo[${localizedIndex}].synopsisShort`}
                          label="Short description"
                          placeholder="Short description..."
                          component="textarea"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustomFormField
                          name={`localizedInfo[${localizedIndex}].synopsisMedium`}
                          label="Medium description"
                          placeholder="Medium description..."
                          component="textarea"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustomFormField
                          name={`localizedInfo[${localizedIndex}].synopsisLong`}
                          label="Long description"
                          placeholder="Long description..."
                          component="textarea"
                        />
                      </Grid>
                    </Grid>
                  )}
                </>
              );
            }}
          />
        </AccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default LocalizedTextsAccordion;
